export default class TermostatFilterCriteria {
    pushButton: boolean | null = null
    touchButton: boolean | null = null
    black: boolean | null = null
    white: boolean | null = null
    bigScreen: boolean | null = null
    embeddedInSwitch: boolean | null = null
    withWiFi: boolean | null = null
    withWires: boolean | null = null
    wireless: boolean | null = null
    cooling: boolean | null = null
    heating: boolean | null = null
}
